import extend from '../extend/u-extend.js';
import ajax from '../ajax/u-ajax.js';

export default function (settings = {}, ids = false) {

	let defaults = {
		url: null,
		onSuccess: () => {},
		onError: () => {}
	};

	if (typeof settings === 'string') {
		settings = {
			url: settings
		};
	}

	settings = extend(true, defaults, settings);

	return new Promise(async (resolve, reject) => {

		try {
			var url = new window.URL(settings.url, document.location);
		}
		catch (err) {
			reject(new Error('Error while parsing url'));
		}

		// Ensure we have an array of id's with no leading hash sign
		ids = []
			.concat(ids || [url.hash])
			.map(function (x) { return x.replace('#', ''); });

		if (ids.length === 0) {
			reject(new Error('getFragments is missing id\'s.'));
		}

		// IE seems to sometimes escape the hash part and send it along to the server.
		// This might cause an error, so we have to take the hash part away before requesting
		url.hash = '';
		settings.url = url;

		try {
			let response = await ajax({
				url: settings.url
			});

			let matched_elements = document.createDocumentFragment();
			const content = document.createElement('div');
			content.innerHTML = response;

			let nodes = content.childNodes;

			if (nodes.length === 0) {
				console.warn('Found no content at ' + url);
			}

			ids.forEach((id) => {
				let element;
				let fragment = '#' + id;

				if (nodes.length === 1 && nodes[0].id === id) {
					element = nodes;
				}
				else {
					element = content.querySelector(fragment);
				}

				if (element) {
					matched_elements.appendChild(element);
				}
				else {
					console.warn('Couldn\'t find element ' + fragment);
				}
			});

			if (typeof settings.onSuccess === 'function') {
				settings.onSuccess(matched_elements.childNodes);
			}

			resolve(matched_elements.childNodes);
		}
		catch (error) {

			if (typeof settings.onError === 'function') {
				settings.onError(error);
			}

			reject(error);
		}

	});
}


// WEBPACK FOOTER //
// ./js/utilities/get-fragment/u-get-fragment.js